import type { QueryParamConfig } from 'use-query-params';
import type { BrandInsightsPageContext } from '@/types';

type ContextItem = BrandInsightsPageContext.Item;

export const ContextItemParam: QueryParamConfig<ContextItem> = {
  encode: (state: ContextItem) => state ? Buffer.from(JSON.stringify(state)).toString('base64') : undefined,
  decode: (q: string) => q ? JSON.parse(Buffer.from(q, 'base64').toString()) as ContextItem : undefined,
};